import { CamposGenericos } from "./camposGenericos";

export class ZonaVendedor extends CamposGenericos {
    autor: string;
    descripcion: string;
    fechaCreacion: Date;
    habilitacion: boolean;
    id: string;
    idCompania: string
    idDivision: string;
    idPais: string;
    idRegion: string;
    idSalesOrg: string;
    usuarioVendedor: string;
    email: string
    telefono1: string
    telefono2: string
}
